<template>
    <div style="height: 30vh;  margin: auto">
        <el-row style="padding-bottom: 25px;">
            <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="line-height:40px;height:40px;margin-bottom:10px;background-color:#042340;text-align: center;margin-right: 10px;">{{form.name}}</el-col>
        </el-row>
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top: 20px">
            <el-col :xl="11" :lg="11" :md="11" :sm="11" :xs="11" style="line-height: 28px;text-align: right;margin-right: 10px;">当前所属空间：</el-col>
            <el-col :xl="11" :lg="11" :md="11" :sm="11" :xs="11">
                <span style="font-size: inherit;height: 28px;line-height: 28px;">{{ spaceValue }}</span>
            </el-col>
        </el-col>
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top: 20px;">
            <el-col :xl="11" :lg="11" :md="11" :sm="11" :xs="11" style="line-height: 28px;text-align: right;margin-right: 10px;">修改后所属空间：</el-col>
            <el-col :xl="11" :lg="11" :md="11" :sm="11" :xs="11">
                <space-tree-show class="space" ref="space" style="overflow: auto;height: 200px;" @spaceChoose="spaceChoose" :isOpen="isOpen"/>
            </el-col>
        </el-col>
    </div>
</template>

<script>
import SpaceTreeShow from "@/components/space/SpaceTreeShow";

export default {
  name: "BelongsModify",
  components: {SpaceTreeShow},
  props: {
    deviceInfo: {},
    spaceInfoId: {},
    spaceValue: {},
  },
  data() {
    return {
      isLoad: true,
                isOpen:false,
                form: {
                    name: this.deviceInfo.name,
                    note: this.deviceInfo.note
                }
            }
        },
        methods: {
            spaceChoose(spaceInfo) {
                if(this.isLoad == true){
                    this.isLoad=false;
                    this.$refs.space.ztreeObj.selectNode([]);
                }else{
                    if(spaceInfo.type!=1){
                        this.deviceInfo.spaceId=spaceInfo.id;
                        this.deviceInfo.spaceName=spaceInfo.title;
                        console.log(this.deviceInfo);
                        this.$emit("receiveData", this.deviceInfo)
                    }else{
                        this.$message.error('此空间为逻辑空间,无法选择');
                        this.$emit("receiveData", null);
                        this.$refs.space.ztreeObj.selectNode([]);
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>
